module.exports = "<p>\r\n  item-details works!\r\n</p>\r\n"